/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadLtxFilesMutationRequest, AuditSupportBulkUploadLtxFilesMutationResponse, AuditSupportBulkUploadLtxFiles401, AuditSupportBulkUploadLtxFiles403 } from "../models/AuditSupportBulkUploadLtxFiles";
import { buildFormData } from "../.kubb/config";

export function getAuditSupportBulkUploadLtxFilesUrl() {
  const res = { method: 'POST', url: `/audit-support/v1/ltx-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload LTX files
 * {@link /audit-support/v1/ltx-files/bulk-upload}
 */
export async function auditSupportBulkUploadLtxFiles(data: AuditSupportBulkUploadLtxFilesMutationRequest, config: Partial<RequestConfig<AuditSupportBulkUploadLtxFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<AuditSupportBulkUploadLtxFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadLtxFiles401 | AuditSupportBulkUploadLtxFiles403>, AuditSupportBulkUploadLtxFilesMutationRequest>({ method : "POST", url : getAuditSupportBulkUploadLtxFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}